import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth82: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.8,107.2h48c-24.4,69.5-48,0-48,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '140.9 84.4 143.8 87 145 90.5 145 92.7 145 97 145 99.7 144.2 102.3 25.5 102.1 25.5 98.6 25.4 94.8 26.1 91.1 28.4 87.1 30.3 84.3 34.7 81.1 135.2 81.1 140.9 84.4',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.7,74.5c-19.7,28.5,11.4,44.4,11.4,44.4l3.8-7.1,3.3-9.5.9-2.7v-9.1s-1.3-3.5-1.3-3.5l-2.9-2.6-6.4-4.4-8.8-5.4h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.5,119.2l-5.4-8-2.6-9.1v-7.3s.6-3.7.6-3.7l4.3-6.8,4.3-3.2,15.8-7.5c13.4,28.3-17,45.6-17,45.6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.8,90.7l.6,4.8-1,6.2-1.9,6.4-2.5,6.9-3.7,6.2-3.7,5.2-4.4,4.5-5.1,4.8-5.2,2.9-7.2,2.8-6.8,2-7.9,1.4-9.7.2-4.2-.7-5.8-1.5-6.2-1.9-6.5-2.1-8-2.7-8.3-4.4-4.5-2.7-6.7-6.5-4.5-4.9-4.5-7.2-1-3.3-1-5.1.3-8.3,2.5-5.9c48.7,19.3,116.9,2.9,116.9,2.9h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.6,90.8c-77.2,16.3-116.9-2.9-116.9-2.9l1.6-2.4,2.7-3.4,5-2.9,6.1-2.9,6-2.2,2.9-2.6,3.3-3.3,4.4-4.6,5.5-4.9,5.1-3.7,4.3-3.1,4.6-1.7,10.6-.3,3,.9,3,1.7,5.1,2.6,5.3,3.5,6.6,5.2,6.8,5.8,6.2,5.1,9.3,6.2,8.7,5.5,1,4.3h-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.2,135.7c-10,4.8-20.2,8.7-31.2,8.9-9.4.2-17.8-3.7-26.5-6.1-19.5-5.3-40.1-21.9-39.1-41.5s6.8-16.1,15.7-19c13.9-4.5,17.7-15.2,31.8-24.2,14.7-9.3,28.9.5,41.4,11.8,10.1,9.1,20.5,14.3,27.8,20.4s2.9,8.9,2.3,12.6c-2.7,15-10.2,27.4-22.3,37.1Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.3,386.5A11,11 0 1 0 68.3,386.5A11,11 0 1 0 90.3,386.5Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M126.5,425l-1.2-25.5c-36.6,12.4,1.2,25.5,1.2,25.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.2,398c33,13.6-3.8,27-3.7,27v-3.3s.6-6.2.6-6.2l1.5-8.5,1.6-8.9h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.4,364.8l-1.7-9.1c-38.1-29-73.7.3-73.7.3l-1.2,8.5c41.7-32.2,76.6.2,76.6.2h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M93.3,463.9h14.7s10.1-.2,10.1-.2l3-.6,2.7-2.4,1.1-1.3.8-2.6,1.6-7.9-.7-23.9-1.2-25.5-3.2-24.2c-30.2,9.4-28.9,88.6-28.9,88.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39.3,374.8c22.4,0,22.5,89.6,22.5,89.6l-11.9-.3-5.7-1.2-5.1-2-3.2-1.7-3.4-3-2.8-3.8-1.4-5.3v-16.7s1.1-5.2,1.2-5.2v-3.3s.6-6.2.6-6.2l3.2-17.5v-3.6s1.4-5,1.4-5l1.5-5.7,1.6-5.2,1.6-3.9h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.7,364.7c-39.6-33-76.6-.2-76.6-.2l-3.4,10.3-1.7,4.2-1,3.3-3.5,12.2v3.6s-1.5,8.5-1.5,8.5l-1.6,9-.7,6v3.5s-1.1,5.2-1.1,5.2v16.7s1.4,5.4,1.4,5.4l2.9,3.9,3.3,2.9,3.3,1.7,5,1.9,5.7,1.2,11.9.3,20.2-.3,11.1-.3h24.8s3-.6,3-.6l3.8-3.7.8-2.6,1.6-7.9-.6-18.3-1.4-31.2-3.2-24.2-2.8-10.5h.3Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.6,463.9l-34.5.3c-17.4.1-44.5,2.1-49.3-12.7-3.2-9.8-2.2-19.8-1-29.8,2.3-18.7,6.2-36.1,12.1-54.3,5.5-6.9,12.8-12.4,21.3-16.1,20.8-9.3,41.3-1,56.8,14.8,3.4,11.4,5.1,22.4,5.6,34.2l1.8,43.8c.2,5.7,0,11.4-3.3,16.1s-5.7,3.8-9.4,3.8Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.8,115.7h41.2c-22.3,97-41.2,0-41.2,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.4,90.9l-1.1-32.3c54.8,9.3,1.1,32.3,1.1,32.3Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M133.1,89.1l2.5-31c-51.8,12.6-2.5,31-2.5,31Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '26.4 53.2 26.9 52 28 47.5 31.1 43 36.9 39.2 48 34.5 61.9 32.4 82.3 31.3 98.7 32.7 118.3 32.9 128.6 35 134.8 40.3 135.6 53 26.4 53.2',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.1,164.2c-43.3,35.8-76.2,0-76.2,0l-1.5-9.9c40.2,41.8,79.8,0,79.8,0,0,0-2.1,9.9-2.1,9.9Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.8,32.9s2.4,114.1,21.7,114.1l2.3-7,3.7-12.3,3.4-16.1,3.3-22.4,2.5-31v-5s-.8-12.8-.8-12.8l-6-5.1-9.5-2.2-20.7-.4v.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.9,32.3s-4.6,112.7-24.3,112.7l-4.7-17.3-2.9-12.9-2.3-13.3-2.1-19.6-.3-23.4,1.1-5.4,1.5-5.5,3.4-4.8,5.6-3.7,11.1-4.6,13.9-2.1h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.3,154.2c-44.1,42.6-79.8,0-79.8,0l-1.8-9.2-1.7-6-4.1-16.2-2.2-10.2-1.5-8.7-.3-2-1.2-11.1-.9-8.9-.3-23.4,1.1-5.4,1.5-5.5,3.2-4.8,5.9-3.8,10.8-4.6,14.2-2.1,20.2-1.1,16.5,1.4,20.4.3,9.3,2.1,6.3,5.2.7,12.9v7.1s-1.3,15.9-1.3,15.9l-1.2,13-2.8,20.6-3.9,17.8-6,19.3-1.2,7.5h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.3,172.5c-11.9,10.1-26.5,9.6-37.9,0s-15.6-18.7-21.9-30.4c-6.3-19.2-9.7-39.2-11.7-59.9s-1.4-22.1,1.9-32.7,8.3-10.3,14.5-12.3c19.1-6.3,38.8-6.3,58.8-4.2s34.1-2.3,34.2,14.1c.2,29.9-3.7,59.1-10.9,88-6.7,14.2-14.8,27.3-26.9,37.4Z',
			},
		},
	},
};
